/**
 * Shared guest-chat config + types.
 *
 * Lives outside the `'use server'` action file because such files may only
 * export async functions — this constant/type is imported by both the server
 * action and the client component.
 */

/** Free messages a logged-out visitor gets before the signup wall. Tune / A-B.
 * Data (2026-08-04): at 5, 11/49 guests hit the wall and 73% of them signed
 * up. Data (2026-08-06, one week at 3): 36 hit the wall but only 6 signed up
 * (16%) — guests weren't invested yet and 19 of 36 just hopped to another
 * character. Reverted to 5: fewer wall hits, far hotter intent. */
export const GUEST_FREE_MESSAGES = 5;

/** Cookie holding how many free guest messages have been used. */
export const GUEST_COOKIE_NAME = 'edem_guest_chat';

/** Parse the guest-used count from the cookie value (clamped, never NaN). */
export function parseGuestUsed(raw: string | undefined): number {
  if (!raw) return 0;
  const n = Number.parseInt(raw, 10);
  return Number.isFinite(n) && n >= 0 ? Math.min(n, GUEST_FREE_MESSAGES) : 0;
}

export interface SendGuestResult {
  success: boolean;
  reply?: string;
  /** Free messages consumed so far (including this one on success). */
  used: number;
  /** Free messages remaining after this call. */
  remaining: number;
  /** True once the free quota is exhausted — the client shows the signup wall. */
  limitReached?: boolean;
  error?: string;
}
